import { create} from "zustand"

import Product from "../model/Product";
import Apartment from "../model/Apartment";
import Material from "../model/material/Material"

interface ProductModel
{
    products: Product[];
    apartments: Apartment[];
    materials: Material[];

    rootProductLoadingStates: Record<string, boolean>; 
    
    setValues: (products: Product[], apartments: Apartment[], materials: Material[]) => void;
    setRootProductLoadingState: (productGuid: string, isLoading: boolean) => void;  
}

export const useProductModelStore = create<ProductModel>()(
    (set) => ({
        products: [],
        apartments: [],
        materials: [],
        rootProductLoadingStates: {},
        
        setValues: (products = [], apartments = [], materials = []) => {
            // Ensure products is an array to avoid errors
            if (!Array.isArray(products)) {
                console.warn('setValues: products is not an array');
                return;
            }

            // Create loading states for products
            const loadingStates = products.reduce(
                (acc: Record<string, boolean>, product) => {
                if (product.globalId) {
                    acc[product.globalId] = false; // Initialize as not loading
                }
                return acc;
                },
                {} // Initial empty object
            );

            // Update state in a single set call
            set({
                products,
                apartments,
                materials,
                rootProductLoadingStates: loadingStates,
            });
        },
        setRootProductLoadingState: (productGuid: string, isLoading: boolean) => {
            set((state) => {
            // Check if productGuid exists in rootProductLoadingStates
            if (!(productGuid in state.rootProductLoadingStates)) {
                return state; // Return unchanged state if productGuid doesn't exist
            }

            return {
                rootProductLoadingStates: {
                ...state.rootProductLoadingStates,
                [productGuid]: isLoading,
                },
            };
            });
        },
    })
);
